module.exports = __webpack_public_path__ + "static/media/banner_cat.54f5902e.png";